import { Component } from 'react'

import PartiesTab from "./PartiesTab"

class PartiesTabContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: "",
            isArchived: false,
            openModal: "",
        }
    }

    toggleTab = (tabId) => {
        this.props.navigate({ hash: this.state.tab })
        this.setState({ tab: tabId })
    }

    render() {
        return (
            <div className="overview-tab-container parties-management">
                <div className="parties-management__header">
                    <div>
                        <div className="parties-management__title">Parties Management</div>
                        <div className="parties-management__subtitle">Manage all parties involved in the incident</div>
                    </div>
                    <div className="parties-management__toggle">
                        <strong>Show Archived</strong>
                        <i
                            className={`fa fa-toggle-${!this.state.isArchived ? "off" : "on"} archive-toggle-icon ${!this.state.isArchived ? "toggle-red" : "toggle-green"}`}
                            onClick={() => this.setState({ isArchived: !this.state.isArchived })}
                        />
                    </div>
                </div>
                <PartiesTab loading={this.props.loading} id={this.props.id} refetchQuery={this.props.refetchQuery} isArchived={this.state.isArchived} />
            </div>
        )
    }
}

export default (PartiesTabContainer)
